import { asyncAction, http } from '../util';
import { getFundamentals } from './constants';
import { isEmpty } from '../util/lodash';

/**
 * Network request to get fundamentals data
 */
export const fundamentalsRequest = asyncAction({
  baseName: 'GET_FUNDAMENTALS_DATA',
  action: action => accountNumber => dispatch => {
    dispatch(action.start({ accountNumber }));
    return http
      .get(`${import.meta.env.VITE_FUNDAMENTALS_URL}/api/rules/v1/${accountNumber}`)
      .then(({ data }) => dispatch(action.success({ accountNumber, data })))
      .catch(({ message }) => dispatch(action.error(message)));
  }
});

/**
 * Dispatches an event to get fundamental data
 * @param {string} accountNumber
 */
export const getFundamentalData = accountNumber => (dispatch, getState) => {
  if (isEmpty(getFundamentals(getState(), accountNumber))) dispatch(fundamentalsRequest(accountNumber));
};
